import IAsset from "../../../models/IAsset";

interface ImageAssetPreviewProps {
  asset: IAsset;
}

export default function ImageAssetPreview({ asset }: Readonly<ImageAssetPreviewProps>) {
  if (!asset) return null;
  return (
    <div>
      <img src={`/api/Asset/${asset.blobPath}`} alt={asset.name} title={asset.name} />
    </div>
  );
}
